import React from 'react';
import SectionSettings from '../SectionSettings';

const AdminStory = () => <SectionSettings sectionKey="story" />;

export default AdminStory;
